import { LogOut } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "../auth";
import { Modal } from "../components";
import { countQueuedMutations } from "../offline-queue";

export function LogoutDialog({ open, onClose }: { open: boolean; onClose(): void }) {
  const { logout } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [pending, setPending] = useState<number | null>(null);
  useEffect(() => {
    if (!open) return;
    let active = true;
    setError(""); setPending(null);
    void countQueuedMutations().then((value) => { if (active) setPending(value); }).catch(() => undefined);
    return () => { active = false; };
  }, [open]);
  const exit = async () => {
    setBusy(true); setError("");
    try { await logout(); }
    catch { setError("No hemos podido cerrar la sesión en el servidor. Comprueba la conexión y vuelve a intentarlo; tu cuenta sigue abierta."); }
    finally { setBusy(false); }
  };
  return <Modal open={open} title="¿Cerrar sesión?" onClose={() => { if (!busy) onClose(); }}>
    <div className="form-stack">
      <p>Saldrás de Cochegest en este navegador. Los datos guardados seguirán en tu cuenta.</p>
      {pending !== null && pending > 0 && <p className="form-error" role="status">Tienes {pending} {pending === 1 ? "cambio pendiente" : "cambios pendientes"} de enviar. Se conservarán en este dispositivo para sincronizarlos al volver a entrar con esta cuenta.</p>}
      {pending === null && <p className="form-helper">Si tienes cambios sin conexión, vuelve a entrar con esta misma cuenta y dispositivo para sincronizarlos.</p>}
      {error && <p className="form-error" role="alert">{error}</p>}
      <div className="form-actions"><button type="button" className="button button--secondary" disabled={busy} onClick={onClose}>Seguir trabajando</button><button type="button" className="button button--primary" disabled={busy} onClick={() => void exit()}><LogOut />{busy ? "Cerrando sesión…" : "Cerrar sesión"}</button></div>
    </div>
  </Modal>;
}
